import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LoginPage = () => {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      sessionStorage.setItem('nde_admin_token', response.data.access_token);
      navigate('/admin/blog');
    } catch (error) {
      setError('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4" data-testid="login-page">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <h1 className="font-rubik text-3xl font-bold text-[#aaae10] mb-2">ADMIN LOGIN</h1>
          <p className="font-roboto text-gray-600">NDE Business Blog Management</p>
        </div>

        <form onSubmit={handleSubmit} data-testid="login-form">
          <div className="mb-4">
            <label htmlFor="username" className="block font-rubik font-medium mb-2">
              Username
            </label>
            <input
              type="text"
              id="username"
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded font-roboto focus:outline-none focus:border-[#aaae10]"
              data-testid="username-input"
            />
          </div>

          <div className="mb-6">
            <label htmlFor="password" className="block font-rubik font-medium mb-2">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              className="w-full px-4 py-3 border border-gray-300 rounded font-roboto focus:outline-none focus:border-[#aaae10]"
              data-testid="password-input"
            />
          </div>

          {error && (
            <div className="mb-4 p-3 bg-red-100 text-red-800 rounded" data-testid="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full btn-primary disabled:opacity-50"
            data-testid="login-submit-button"
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
